<template>
  <div>
    <CustomDialog
      :show="show"
      :title="$t('public.addNtrip')"
      @toggleShow="handleClose"
      :appendToBody="true"
      width="800"
    >
      <div slot="main">
        <div class="info">
          <el-form
            :model="form"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="170px"
            class="demo-ruleForm"
            size="small"
          >
            <el-form-item :label="$t('public.username')" prop="username">
              <el-input
                v-model.trim="form.username"
                autocomplete="off"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.password')" prop="password">
              <el-input
                maxlength="50"
                show-password
                type="password"
                v-model.trim="form.password"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.online')" prop="online">
              <el-input v-model="form.online" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item :label="$t('public.bsSearch')">
              <el-input
                :placeholder="$t('public.p3')"
                v-model="form.searchKey"
                size="small"
                @keyup.enter.native="toSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="toSearch"
                ></el-button>
              </el-input>
            </el-form-item>
            <el-form-item :label="$t('public.bsGroup')" prop="group">
              <div class="group">
                <div>
                  <el-select
                    v-model="form.group"
                    :placeholder="$t('public.p8')"
                    @change="stationChange"
                  >
                    <el-option
                      v-for="item in groups"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-checkbox
                    style="margin-left: 20px"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                    >{{ $t("public.checkAll") }}</el-checkbox
                  >
                </div>
                <div style="text-align: right">
                  {{ $t("public.hasAuth") + form.stationValue.length }}
                </div>
              </div>
            </el-form-item>
            <div class="checkGroup" ref="checkGroup" @scroll="handleScroll">
              <el-checkbox-group
                v-model="form.stationValue"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  v-for="station in stations"
                  :label="station.id"
                  :key="station.id"
                  >{{ station.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <div class="btns">
          <el-button
            @click="confirm"
            type="primary"
            size="small"
            style="width: 100%"
            >{{ $t("public.submit") }}</el-button
          >
          <el-button @click="handleClose" size="small" style="width: 100%">{{
            $t("public.cancel")
          }}</el-button>
        </div>
      </div>
    </CustomDialog>
  </div>
</template>

<script>
import {
  addUsers,
  getStations,
  getStaGroupNameList,
  getStaGroupStasList,
} from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "OverseasStationManageViewList",
  components: {
    CustomDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "view",
    },
  },
  data() {
    return {
      options: [
        {
          value: "0",
          label: "全部",
        },
      ],
      groups: [
        {
          value: "0",
          label: "全部",
        },
      ],
      form: {
        username: "",
        password: "",
        online: 100,
        // role: "",
        group: "",
        searchKey: "",
        stationValue: [],
      },
      rules: {
        username: [
          { required: true, message: this.$t("public.ver1"), trigger: "blur" },
        ],
        password: [
          { required: true, message: this.$t("public.ver2"), trigger: "blur" },
        ],
        online: [
          { required: true, message: this.$t("public.ver4"), trigger: "blur" },
        ],
      },
      checkAll: false,
      checkedStations: [],
      stations: [],
    };
  },
  watch: {
    show: {
      handler(newV, oldV) {
        this.getGroupNameList();
        this.getBsGroup();
      },
    },
  },
  mounted() {
    // this.getAllCheckValue();
  },

  methods: {
    stationChange(e) {
      this.getGroupToList().then((res) => {
        this.checkAll = true;
        this.handleCheckAllChange(this.checkAll);
      });
      // console.log(e, "eeee")
    },
    async getGroupToList() {
      let param = {
        groupId: this.form.group,
      };
      this.stations = [];
      let res = await getStaGroupStasList(param);
      this.stations = res.data.map((item) => {
        return {
          label: item.nm,
          id: item.nm,
        };
      });
    },
    getBsGroup() {
      this.groups = [];
      getStaGroupNameList().then((res) => {
        if (res.data) {
          this.groups = res.data.map((item) => {
            return {
              label: item.groupName,
              value: item.groupId,
            };
          });
        }
      });
    },
    handleScroll() {
      const container = this.$refs.checkGroup;
      const scrollHeight = container.scrollHeight;
      const scrollTop = container.scrollTop;
      const clientHeight = container.clientHeight;
      if (scrollTop + clientHeight >= scrollHeight && !this.loading) {
        // this.loadMore()
        console.log("到底了");
      }
    },
    getGroupNameList() {
      getStations().then((res) => {
        this.stations = res.data.map((item) => {
          return {
            label: item.nm,
            id: item.nm,
          };
        });
      });
    },
    getAllCheckValue() {
      this.checkedStations = this.stations.map((item) => {
        return item.id;
      });
    },
    handleCheckAllChange(val) {
      this.checkedStations = this.stations.map((item) => {
        return item.id;
      });
      this.form.stationValue = val ? this.checkedStations : [];
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.stations.length;
      //   this.isIndeterminate =
      //     checkedCount > 0 && checkedCount < this.stations.length;
    },
    toSearch() {
      // console.log("搜索");
      let param = {
        stationName: this.form.searchKey,
      };
      this.stations = [];
      getStations(param).then((res) => {
        if (res.data)
          this.stations = res.data.map((item, index) => {
            return {
              label: item.nm,
              id: item.nm,
            };
          });
      });
    },
    confirm() {
      let param = {
        username: this.form.username,
        password: this.form.password,
        limit: Number(this.form.online),
        // stations: this.form.stationValue.join("|"),
      };
      // if (this.checkAll) {
      //   param.staGroupId = this.form.group ? this.form.group : this.form.stationValue.join("|");
      // } else {
      //   param.stations = this.form.stationValue.join("|");
      // }
      if (this.groups.length) {
        // 如果有基站组
        if (this.checkAll) {
          // 不选择基站组直接全选
          if (this.form.group) {
            param.staGroupId = this.form.group;
          } else {
            param.stations = this.form.stationValue.join("|");
          }
        } else {
          param.stations = this.form.stationValue.join("|");
        }
      } else {
        // 没有基站组只能选择基站
        param.stations = this.form.stationValue.join("|");
      }
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (!param.staGroupId && !param.stations) {
            this.$message.warning(this.$t("public.notEmpty"));
            return;
          }
          addUsers(param).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.$t("public.success2"));
              this.$emit("refush");
              this.handleClose();
            }
          });
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("update:show", false);
      this.form = {
        username: "",
        password: "",
        online: 100,
        // role: "",
        group: "",
        searchKey: "",
        stationValue: [],
      };
      this.checkAll = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkGroup {
  border: 1px solid #eeeeee;
  padding: 10px;
  max-height: 100px;
  margin-left: 10px;
  overflow: auto;
}
.group {
  display: flex;
  justify-content: space-between;
}
</style>
